'use strict';exports.__esModule = true;var rangeKeys = ['min', 'max'];
var arrayKeys = ['type'];

var translationKeysMap = {
  type: ['propertyTypes'],
  min: ['price'],
  max: ['price'] };


var formatArrayValues = function formatArrayValues(data, translate) {
  var result = [];
  arrayKeys.forEach(function (key) {
    var values = data[key];
    if (!values || !values.length) {return;}

    var arrayValues = values instanceof Array ? values : [values];

    var formatted = arrayValues.map(function (value) {return {
        value: key + '__' + value,
        label: translate.apply(undefined, translationKeysMap[key].concat([value])) };});


    result.push.apply(result, formatted);
  });

  return result;
};

var formatRangeValues = function formatRangeValues(data, translate) {
  var result = [];

  rangeKeys.forEach(function () {var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var value = data[key];
    if (!value) {return;}

    var isMinValue = key.includes('min');
    var prefix = isMinValue ? 'from' : 'to';

    var formattedValue = {
      currency: data.currency,
      value: key,
      label: translate.apply(undefined, translationKeysMap[key].concat([prefix])) + ' ' + value };


    result.push(formattedValue);
  });

  return result;
};

var formatForeignFilterValuesForChips = function formatForeignFilterValuesForChips(query, translate) {
  var formatted = [];

  var arrayValues = formatArrayValues(query, translate);
  formatted.push.apply(formatted, arrayValues);

  var rangeValues = formatRangeValues(query, translate);
  formatted.push.apply(formatted, rangeValues);

  return formatted;
};exports.default =

formatForeignFilterValuesForChips;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForeignPropertiesListContainer/helpers.js
// module id = 2945
// module chunks = 0